import React from 'react';
import Layout from '../containers/Layout';
import PageTitle from '../components/PageTitle';
import BracketList from '../containers/BracketList';

const Brackets = () => (
  <Layout>
    <PageTitle messageId="app.brackets" />
    <BracketList />
  </Layout>
);

export default Brackets;
